var map = {
	"./add-pipeline.svg": "a0cb",
	"./arrow-down.svg": "0f7b",
	"./board-view.svg": "bce4",
	"./close-s.svg": "f827",
	"./close.svg": "4a9f",
	"./copy-id.svg": "d532",
	"./filter-fill.svg": "98e1",
	"./filter.svg": "b71c",
	"./list.svg": "7777",
	"./qrcode.svg": "5d9a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0689";